import { IValidate } from "../../../interfaces/IValidate";
import { TextValidator } from "../../validators/TextValidator";
import { NumberValidator } from "../../validators/NumberValidator"
import { CurrencyValidator } from "../../validators/CurrencyValidator";
import { HyperLinkValidator } from "../../validators/HyperLinkValidator"
import { CollectionValidator } from "../../validators/CollectionValidator";
import { NoValidation } from "../../validators/NoValidation";
import { PickerValidator } from "../../validators/PickerValidator";
import { IValidationProperties } from "../../../interfaces/IValidationProperties";
import { PercentageValidator } from "../../validators/PercentageValidator";
import { DateValidator } from "../../validators/DateValidator";
import { TaxonomyValidator } from "../../validators/TaxonomyValidator";

export class ValidatorFactory {

    static createTextValidator(validationProperties: IValidationProperties): IValidate {
        return new TextValidator(validationProperties); //only uses base validator
    }

    static createNumberValidator(validationProperties: IValidationProperties): IValidate {
        return new NumberValidator(validationProperties); //uses event.target.max /min
    }

    static createPercentageValidator(validationProperties: IValidationProperties): IValidate {
        return new PercentageValidator(validationProperties); //uses event.target.max /min
    }

    static createCurrencyValidator(validationProperties: IValidationProperties): IValidate {
        return new CurrencyValidator(validationProperties);  //uses event.target.max /min
    }

    static createHyperLinkValidator(validationProperties: IValidationProperties): IValidate {
        return new HyperLinkValidator(validationProperties); //only uses base validator
    }

    static createCollectionValidator(validationProperties: IValidationProperties): IValidate {
        return new CollectionValidator(validationProperties); //uses aria required
    }

    static createNoValidation(validationProperties: IValidationProperties): IValidate {
        return new NoValidation(validationProperties); //returns success
    }

    static createPickerValidation(validationProperties: IValidationProperties): IValidate {
        return new PickerValidator(validationProperties); //has no event
    }

    static createDateValidation(validationProperties: IValidationProperties): IValidate {
        return new DateValidator(validationProperties); //has no event
    }

    static createTaxonomyValidation(validationProperties: IValidationProperties): IValidate {
        return new TaxonomyValidator(validationProperties); //has no event
    }
}
